import { SearchOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { Badge, Col, Modal, Pagination, Row, Switch, Table, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import Input from "../../components/Input/Input";
import { CardContainer } from "../../components/Card/CardContainer";
import { RangePicker } from "../../components/DatePicker/DatePicker";
import Text from "../../components/Text/Text";
import { FlexCol } from "../../components/Container/Container";
import Button from "../../components/Button/Button";
import { color, icon, image } from "../../resource";
import {
  changeStatusProductQuota,
  deleteProductQuota,
  getProductQuotaList,
} from "../../datasource/ProductQuotaDatasource";
import { dateFormatter } from "../../utility/Formatter";
import SortFieldCustom from "../../components/SortFieldTable/SortFieldCustom";
import { useNavigate } from "react-router-dom";
import Permission, { checkPermission } from "../../components/Permission/Permission";
import { useRecoilValue } from "recoil";
import { roleAtom } from "../../store/RoleAtom";
import { MAP_QUOTA_TYPE, STATUS_WORD, STATUS_WORD_COLOR } from "../../definitions/QuotaType";
import useSorting from "../../hook/useSorting";
import ModalCheckQuotaDup from "../../components/Modal/ModalCheckQuotaDup";
import ModalProductDupQuota from "../../components/Modal/ModalProductDupQuota";
import TablePagination from "../../components/Table/TablePagination";
import StatusBadge from "../../components/Badge/StatusBadge";

const REQUEST_DMY = "YYYY-MM-DD";

export const IndexProductQuota: React.FC = () => {
  const navigate = useNavigate();
  const roleData = useRecoilValue(roleAtom);
  const isPermissionEdit = checkPermission(["productQuota", "edit"], roleData);
  const pageSize = 10;
  const [page, setPage] = useState<number>(1);
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const [keyword, setKeyword] = useState<string>();
  const [dateFilter, setDateFilter] = useState<any>();
  const [selectedTab, setSelectedTab] = useState<any>("All");
  const { sortField, sortDirection, handleSortChange } = useSorting();
  const [quotaDup, setQuotaDup] = useState(false);
  const [productDupQuotaVisible, setProductDupQuotaVisible] = useState(false);

  const [data, setData] = useState<{
    count: number;
    data: any[];
    statusCount: {
      ACTIVE: number;
      ALL: number;
      EXPIRED: number;
      INACTIVE: number;
      WAITTING: number;
    };
  }>({
    count: 0,
    data: [],
    statusCount: {
      ACTIVE: 0,
      ALL: 0,
      EXPIRED: 0,
      INACTIVE: 0,
      WAITTING: 0,
    },
  });
  const [modalType, setModalType] = useState<string>();
  const [status, setStatus] = useState<boolean>(false);
  const [quotaId, setQuotaId] = useState<any>();
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const [warningModal, setWarningModal] = useState<boolean>(false);
  const [dataPDDup, setDataPDDup] = useState<any>();
  const [loading, setLoading] = useState(false);

  const getProdQuotaList = async () => {
    setLoading(true);
    try {
      await getProductQuotaList({
        company: userProfile?.company,
        status: selectedTab,
        search: keyword,
        page: page,
        take: pageSize,
        startDate: dateFilter && dateFilter[0] ? dateFilter[0].format(REQUEST_DMY) : undefined,
        endDate: dateFilter && dateFilter[1] ? dateFilter[1].format(REQUEST_DMY) : undefined,
        sortBy: sortDirection ? sortField : undefined,
        sortDirection: sortDirection,
      }).then((res) => {
        setData(res);
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProdQuotaList();
  }, [selectedTab, keyword, page, dateFilter, sortField, sortDirection]);

  const ActionBtn = ({ onClick, icon, disabled }: any) => {
    return (
      <Col span={6}>
        <div
          className={`btn btn-icon btn-light btn-hover-primary btn-sm ${disabled ? "disabled" : ""}`}
          onClick={(e) => {
            if (!disabled && onClick) onClick(e);
          }}
          style={{ cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1 }}
        >
          <span
            className='svg-icon svg-icon-primary svg-icon-2x'
            style={{ color: color["primary"] }}
          >
            {icon}
          </span>
        </div>
      </Col>
    );
  };

  const PageTitle = () => {
    return (
      <Row align='middle' gutter={16}>
        <Col className='gutter-row' span={9}>
          <div>
            <span
              className='card-label font-weight-bolder text-dark'
              style={{ fontSize: 20, fontWeight: "bold" }}
            >
              รายการโควตาสินค้า
            </span>
          </div>
        </Col>
        <Col span={5}>
          <Input
            allowClear
            placeholder='ค้นหาชื่อโควตา'
            suffix={<SearchOutlined />}
            defaultValue={keyword}
            onPressEnter={(e) => {
              const value = (e.target as HTMLTextAreaElement).value;
              setKeyword(value);
              setPage(1);
            }}
            onChange={(e) => {
              const value = (e.target as HTMLInputElement).value;
              if (!value) {
                setKeyword("");
              }
            }}
          />
        </Col>
        <Col span={7}>
          <RangePicker
            allowEmpty={[true, true]}
            enablePast
            value={dateFilter}
            onChange={(dates, dateString) => {
              setDateFilter(dates);
              setPage(1);
            }}
          />
        </Col>
        <Permission permission={["productQuota", "create"]}>
          <Col>
            <Button
              type='primary'
              title='+ สร้างโควตา'
              height={40}
              onClick={() => navigate("/productQuota/create")}
              size='large'
              //disabled={!checkPermission(["productQuota", "create"], roleData)}
            />
          </Col>
        </Permission>
      </Row>
    );
  };

  const tabsItems = [
    {
      label: <Text fontSize={14}>{`ทั้งหมด (${data?.statusCount["ALL"]})`}</Text>,
      key: "ALL",
    },
    {
      label: <Text fontSize={14}>{`รอเริ่ม (${data?.statusCount["WAITING"]})`}</Text>,
      key: "WAITING",
    },
    {
      label: <Text fontSize={14}>{`เปิดใช้งาน (${data?.statusCount["ACTIVE"]})`}</Text>,
      key: "ACTIVE",
    },
    {
      label: <Text fontSize={14}>{`ปิดใช้งาน (${data?.statusCount["INACTIVE"]})`}</Text>,
      key: "INACTIVE",
    },
    {
      label: <Text fontSize={14}>{`หมดอายุ (${data?.statusCount["EXPIRED"]})`}</Text>,
      key: "EXPIRED",
    },
  ];

  const columns: any = [
    {
      title: "ชื่อโควตา",
      dataIndex: "quotaName",
      key: "quotaName",
      width: 180,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text fontFamily='Sarabun'>{value}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "รูปแบบโควตา",
      dataIndex: "quotaType",
      key: "quotaType",
      width: 150,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text fontFamily='Sarabun'>{MAP_QUOTA_TYPE[value]}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ช่วงเวลา",
      dataIndex: "startDate",
      key: "startDate",
      width: 150,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>
                {dateFormatter(row.startDate)} - {dateFormatter(row.endDate)}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: (
        <SortFieldCustom
          title='ร้านค้าที่ให้โควตา'
          sortDirection={sortField === "countShop" ? sortDirection : undefined}
          onSortChange={() => handleSortChange("countShop")}
        />
      ),
      dataIndex: "countShop",
      key: "countShop",
      width: 190,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
              <Text level={6} color='Text3' fontFamily='Sarabun'>
                ร้าน
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: (
        <SortFieldCustom
          title='จำนวนสินค้า'
          sortDirection={sortField === "countProduct" ? sortDirection : undefined}
          onSortChange={() => handleSortChange("countProduct")}
        />
      ),
      dataIndex: "countProduct",
      key: "countProduct",
      width: 150,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
              <Text level={6} color='Text3' fontFamily='Sarabun'>
                รายการ
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: (
        <SortFieldCustom
          title='อัปเดตโดย'
          sortDirection={sortField === "updatedAt" ? sortDirection : undefined}
          onSortChange={() => handleSortChange("updatedAt")}
        />
      ),
      dataIndex: "updatedBy",
      key: "updatedBy",
      width: 150,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text> {dateFormatter(row.updatedAt)}</Text>
              <Text level={6} color='Text3' fontFamily='Sarabun'>
                {value}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      width: 100,
      render: (value: any, row: any, index: number) => {
        const checked = row.status === "ACTIVE" ? true : false;
        return {
          children: (
            <FlexCol>
              {row.statusType === "EXPIRED" ? (
                <Text color='Text3' level={6}>
                  หมดอายุ
                </Text>
              ) : (
                <>
                  {row.statusType === "WAITING" && (
                    <div style={{ paddingBottom: "4px" }}>
                      <Badge
                        count='รอเริ่ม'
                        style={{
                          backgroundColor: color.secondary2,
                          fontFamily: "IBM Plex Sans Thai",
                        }}
                      />
                    </div>
                  )}
                  {isPermissionEdit ? (
                    <Switch
                      key={row.quotaId}
                      checked={checked}
                      style={{
                        width: "85px",
                      }}
                      checkedChildren={checked ? "เปิดใช้งาน" : ""}
                      unCheckedChildren='ปิดใช้งาน'
                      onChange={async (e) => {
                        setQuotaId(row.quotaId);
                        setStatus(e);
                        setModalType("status");
                        setShowConfirm(!showConfirm);
                      }}
                    />
                  ) : (
                    <StatusBadge
                      key={index}
                      label={STATUS_WORD[String(checked)]}
                      bgColor={STATUS_WORD_COLOR[String(checked)]}
                      borderRadius='20px'
                    />
                  )}
                </>
              )}
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "จัดการ",
      dataIndex: "action",
      key: "action",
      width: "12%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row gutter={10} style={{ gap: 6 }} justify='start'>
              <Permission permission={["productQuota", "view"]}>
                <ActionBtn
                  onClick={() => navigate("/productQuota/detail/" + row.quotaId)}
                  icon={
                    <UnorderedListOutlined style={{ width: 16, height: 16, fontWeight: 700 }} />
                  }
                />
              </Permission>
              <Permission permission={["productQuota", "delete"]}>
                <>
                  {(row.statusType === "WAITING" ||
                    (row.status === "INACTIVE" && row.statusType !== "EXPIRED")) && (
                    <ActionBtn
                      disabled={row.notDeleted}
                      onClick={() => {
                        setQuotaId(row.quotaId);
                        setModalType("delete");
                        setShowConfirm(!showConfirm);
                      }}
                      icon={
                        <img
                          src={row?.notDeleted ? icon.deleteText4 : icon.delete}
                          style={{ width: 16, height: 16 }}
                          onClick={() => {
                            setQuotaId(row.quotaId);
                            setModalType("delete");
                            setShowConfirm(!showConfirm);
                          }}
                        />
                      }
                    />
                  )}
                </>
              </Permission>
              <Permission permission={["productQuota", "edit"]}>
                <Col span={6}>
                  <div
                    className='btn btn-icon btn-light btn-hover-primary btn-sm'
                    onClick={() => {
                      Modal.confirm({
                        title: "ต้องการคัดลอกโควตานี้ใช่หรือไม่?",
                        content: `โปรดตรวจสอบรายละเอียดโควตา “${row.quotaName}” ที่ต้องการคัดลอก ก่อนกดยืนยัน`,
                        okText: "ยืนยัน",
                        onOk: () => navigate("/productQuota/duplicate/" + row.quotaId),
                      });
                    }}
                  >
                    <span className='svg-icon svg-icon-primary svg-icon-2x'>
                      <img src={icon.dupplicate} style={{ width: 16, height: 16 }} />
                    </span>
                  </div>
                </Col>
              </Permission>
            </Row>
          ),
        };
      },
    },
  ];

  const changeStatus = async (quotaId: string, checked: boolean) => {
    setShowConfirm(false);
    setLoading(true);
    try {
      const status = checked ? "ACTIVE" : "INACTIVE";
      const name = `${userProfile.firstname} ${userProfile.lastname}`;
      await changeStatusProductQuota({
        quotaId: quotaId,
        status,
        updatedBy: name,
        role: userProfile?.role,
      }).then(async (res) => {
        if (res.success) {
          setQuotaId(undefined);
          setShowConfirm(false);
          await getProdQuotaList();
        } else {
          setShowConfirm(false);
          setQuotaDup(true);
          setDataPDDup(res?.responseData);
        }
      });
    } catch (error) {
      console.log("err update status quota", error);
    } finally {
      setLoading(false);
    }
  };
  const deleteQuota = async (quotaId: string) => {
    setShowConfirm(false);
    setLoading(true);
    try {
      const name = `${userProfile.firstname} ${userProfile.lastname}`;
      await deleteProductQuota({
        quotaId: quotaId,
        updateBy: name,
      }).then(async (res) => {
        setShowConfirm(false);
        if (res.success) {
          setQuotaId(undefined);
          await getProdQuotaList();
        } else {
          if (res.developerMessage.includes("delete")) {
            setWarningModal(true);
          }
        }
      });
    } catch (error) {
      console.log("delete quota", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CardContainer>
        <PageTitle />
        <br />
        <Tabs
          items={tabsItems}
          onChange={(key: string) => {
            setSelectedTab(key);
            setPage(1);
          }}
          defaultValue={"ALL"}
        />

        <TablePagination
          columns={columns}
          data={(data?.data || []).map((item: any, index: number) => {
            return {
              ...item,
              id: index + 1,
            };
          })}
          isLoading={loading}
          locale={{
            emptyText: (
              <div
                style={{
                  padding: 32,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 24,
                  minHeight: 350,
                }}
              >
                <img
                  src={icon.emptyHistoryPoint}
                  style={{
                    width: 80,
                    height: 90,
                  }}
                  alt='empty_table'
                />
                <Text fontFamily='Sarabun' fontSize={14} fontWeight={400} color='Text3'>
                  ไม่มีรายกำหนดโควตาสินค้า
                </Text>
              </div>
            ),
          }}
          scroll={{ x: "max-content" }}
        />
        <div style={{ padding: "22px  0px 22px 0px", display: "flex", justifyContent: "center" }}>
          <Pagination
            current={page}
            total={data?.count || 0}
            onChange={(pageNumber) => setPage(pageNumber)}
            pageSize={10}
            showSizeChanger={false}
          />
        </div>
      </CardContainer>
      {showConfirm && (
        <Modal
          open={showConfirm}
          onCancel={() => setShowConfirm(!showConfirm)}
          title={
            modalType === "status" ? (
              <Text level={3} fontWeight={700}>
                ยืนยันการเปลี่ยนสถานะเป็น {status ? "''เปิดใช้งาน''" : "''ปิดใช้งาน''"}
              </Text>
            ) : (
              <Text level={3} fontWeight={700}>
                ต้องการยืนยันการลบรายการโควตาสินค้า
              </Text>
            )
          }
          centered
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              {modalType === "delete" && (
                <Row justify={"end"} gutter={8}>
                  <Col>
                    <Button
                      title='ยกเลิก'
                      typeButton='border-danger'
                      onClick={() => setShowConfirm(!showConfirm)}
                    />
                  </Col>
                  <Col>
                    <Button
                      title='ยืนยัน'
                      typeButton='danger'
                      onClick={() => deleteQuota(quotaId)}
                    />
                  </Col>
                </Row>
              )}
              {modalType === "status" && (
                <Row justify={"end"} gutter={8}>
                  <Col>
                    <Button
                      title='ยกเลิก'
                      typeButton='primary-light'
                      onClick={() => setShowConfirm(!showConfirm)}
                    />
                  </Col>
                  <Col>
                    <Button
                      title='ยืนยัน'
                      typeButton='primary'
                      onClick={() => changeStatus(quotaId, status)}
                    />
                  </Col>
                </Row>
              )}
            </>
          )}
        >
          <Text color='Text3'>
            โปรดตรวจสอบรายละเอียดอีกครั้ง ก่อนการกดยืนยัน{modalType === "delete" && "การลบ"}
          </Text>
        </Modal>
      )}
      {warningModal && (
        <Modal
          width={350}
          centered
          open={warningModal}
          closable={false}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <Row gutter={8}>
                <Button
                  title='เข้าใจแล้ว'
                  typeButton='primary'
                  onClick={() => {
                    setWarningModal(!warningModal);
                    getProdQuotaList();
                  }}
                />
              </Row>
            </>
          )}
        >
          <Row justify={"center"} style={{ padding: "8px" }}>
            <img src={image.warning_product_quota} />
          </Row>
          <Row justify={"center"}>
            <Text level={4} fontWeight={700}>
              ไม่สามารถลบรายการโควตาสินค้าได้
            </Text>
            <Text color='Text3'>เนื่องจากรายการโควตานี้เข้าสู่วันเริ่มต้น</Text>
          </Row>
          <Row justify={"center"}>
            <Text color='Text3'>ใช้งานโควตาในระบบแล้ว</Text>
          </Row>
        </Modal>
      )}
      <ModalCheckQuotaDup
        visible={quotaDup}
        onCancel={() => setQuotaDup(false)}
        onSubmit={() => {
          setQuotaDup(false);
          setProductDupQuotaVisible(true);
        }}
      />

      <ModalProductDupQuota
        visible={productDupQuotaVisible}
        onCancel={() => setProductDupQuotaVisible(false)}
        onSubmit={() => setProductDupQuotaVisible(false)}
        data={dataPDDup}
      />
    </>
  );
};
